import { useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { DeleteSquare, InfoCircle } from '@/components/Icons.tsx';

const NOTICE_KEY = 'SATPrac:mobileNoticeDismissed';

/**
 * Replaces the old blocking `MobileWarning` dialog.
 *
 * The message is a deliberate product decision -- the real digital SAT is taken
 * on a computer or iPad -- so it is kept, but it must not block the app.
 */
const MobileNotice = () => {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(NOTICE_KEY) === '1'
  );

  if (dismissed || !isMobileOnly) return null;

  const onDismiss = () => {
    localStorage.setItem(NOTICE_KEY, '1');
    setDismissed(true);
  };

  return (
    <div
      role="status"
      className="m:flex fixed left-3 right-3 top-3 z-50 hidden gap-3 rounded-xl
                 border border-dashed border-shade-20 bg-neutral2 p-3 pr-2"
    >
      <InfoCircle className="mt-0.5 shrink-0 text-secondary" width={18} height={18} />
      <div className="flex-1">
        <p className="text-footnote leading-5 text-neutral2-text-strong">
          <strong>Practice tests are built for a computer or iPad.</strong>{' '}
          You can still take them here, but the real digital SAT is sat at a keyboard.
        </p>
        <button
          onClick={onDismiss}
          className="mt-1.5 text-footnote font-semibold text-primary active:text-primary-hover
                     m:flex m:min-h-11 m:items-center m:px-2"
        >
          Got it
        </button>
      </div>
      <button
        onClick={onDismiss}
        aria-label="Dismiss"
        className="h-8 w-8 shrink-0 rounded-md active:bg-shade-10 m:h-11 m:w-11"
      >
        <DeleteSquare className="mx-auto text-neutral2-canvas" width={18} height={18} />
      </button>
    </div>
  );
};

export default MobileNotice;
